import React, { Component } from 'react';
import Formulario from './RegistroCoempaqueForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class RegistroCoempaque extends Component{
    state = {
        crear: true,
        documento: null,
        productoPais: '',
        pais: '',
        parametro: '',
    }

    componentDidMount = () => {
        const { match, leer, getModulo, getPais, listarLicencias, listarVias,
            listarAcondicionadores, listarFabricante, listarProductos,
            listarPaisesOrigen, listarTiposRegistro, listarELZM,
            listarRegistrosSanitarios, limpiarDatos, parametrosEmpresa
        } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
            listarProductos();
            listarFabricante();
            listarAcondicionadores();
            listarELZM();
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        getPais(modulo[7]);
        listarVias();
        listarPaisesOrigen();
        listarLicencias();
        listarTiposRegistro();
        listarRegistrosSanitarios();
        limpiarDatos();
        parametrosEmpresa();
        localStorage.removeItem('id_detalle_registro_co_rs');
    }

    setConstancia = (documento) => {
        this.setState({documento});
    };

    setProductoPais = (productoPais) => {
        this.setState({ productoPais });
    }

    setParametro = (parametro) => {
        this.setState({ parametro });
    }

    setPais = (pais) => {
        this.setState({ pais });
    }

    registroRC = (data) => {
        const { registroRC } = this.props;
        registroRC( {...data, documento: null},
            [{ "file": this.state.documento, "name": 'constancia' }],
            this.state.productoPais,
            this.state.pais,
            this.state.parametro,
        )
    }

    modificarRC = (data) => {
        const { modificarRC } = this.props;
        modificarRC( {...data, documento: null},
        [{ "file": this.state.documento, "name": 'constancia' }])
    }

    render(){
        const { loader, modulo, listaPro, paisN,
            listaAcond, lectura, listaFab, listarRegistrosSanitarios,
            listaCom, listaPaisOrigen, listaVia, lic, tipoRegistro,
            codigoPais, datoRegistro, listRegistroProducto, descripcionProducto,
            buscarProductos, buscarFabricante, buscarAcondicionador,
            registroProducto, listaELZM, agregarLinea, detallePro, eliminarLinea,
            detalleRegistro, agregarLineaRegistro, eliminarLineaRegistro, datos } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    obtenerProductos = {listaPro}
                    obtenerFabricantes = {listaFab}
                    obtenerAcondicionadores = {listaAcond}
                    lectura = {lectura}
                    registroRC = {this.registroRC}
                    modificarRC = {this.modificarRC}
                    paisN = {paisN}
                    obtenerComercializador = {listaCom}
                    obtenerPaises = {listaPaisOrigen}
                    obtenerLicencias = {lic}
                    obtenerVias = {listaVia}
                    obtenerTipoRegistro = {tipoRegistro}
                    codigoPais = {codigoPais}
                    datoRegistro = {datoRegistro}
                    listRegistroProducto = {listRegistroProducto}
                    descripcionProducto = {descripcionProducto}
                    buscarProductos = {buscarProductos}
                    buscarFabricante = {buscarFabricante}
                    buscarAcondicionador = {buscarAcondicionador}
                    registroProducto = {registroProducto}
                    listaELZM = {listaELZM}
                    listarRegistrosSanitarios = {listarRegistrosSanitarios}
                    agregarLinea = {agregarLinea}
                    detallePro = {detallePro}
                    eliminarLinea = {eliminarLinea}
                    detalleRegistro = {detalleRegistro}
                    agregarLineaRegistro = {agregarLineaRegistro}
                    eliminarLineaRegistro = {eliminarLineaRegistro}
                    datos = {datos}
                    setConstancia = {this.setConstancia}
                    setProductoPais = {this.setProductoPais}
                    setPais = {this.setPais}
                    setParametro = {this.setParametro}
                />
            </LoadMask>
        );
    }
}


export default RegistroCoempaque;
